import { GroupInput } from '@/components/v2/group-input'
import { DocumentNumberInput } from '@/components/document-number-input'
import { PhoneNumberInput } from '@/shared/components/phone-number-input'
import { InputHelperText } from '@/shared/components/input-helper-text'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { MutualitySelect } from '@/components/mutuality-selector'

export const SafetyInformationForm = () => {
  const { t } = useTranslation()
  const { values, errors, setFieldValue } = useFormikContext()

  const safetyManager = values.safety_information?.safety_manager ?? {}

  return (
    <>
      <GroupInput title='Mutualidad' className='py-8'>
        <div className='grid grid-cols-2 gap-4'>
          <div className='col-span-2'>
            <MutualitySelect
              name="safety_information.mutuality_id"
              allowNull={values.safety_information?.mutuality_id == null}
            />
          </div>
        </div>
      </GroupInput>

      <GroupInput
        title='Prevencionista de Riesgos'
        description='Contacto del prevencionista de riesgos.'
        className='py-8'
      >
        <div className='grid grid-cols-2 gap-4'>

          <Input
            name="safety_information.safety_manager.full_name"
            label='Nombre completo'
            value={safetyManager.full_name || ''}
            onChange={(e) =>
              setFieldValue('safety_information.safety_manager.full_name', e.target.value)
            }
          />

          <DocumentNumberInput
            name="safety_information.safety_manager.document_number"
            label="RUT"
            value={safetyManager.document_number || ''}
            onChange={(e) =>
              setFieldValue('safety_information.safety_manager.document_number', e.target.value)
            }
            error={Boolean(errors?.safety_information?.safety_manager?.document_number)}
          />

          <div>
            <Input
              name="safety_information.safety_manager.email"
              label="Correo"
              value={safetyManager.email || ''}
              onChange={(e) =>
                setFieldValue('safety_information.safety_manager.email', e.target.value)
              }
              error={Boolean(errors?.safety_information?.safety_manager?.email)}
            />
            <InputHelperText
              label={errors?.safety_information?.safety_manager?.email}
              color="red"
            />
          </div>

          <PhoneNumberInput
            name="safety_information.safety_manager.phone"
            label="Teléfono"
            value={safetyManager.phone || ''}
            onChange={(e) =>
              setFieldValue('safety_information.safety_manager.phone', e.target.value)
            }
          />

        </div>
      </GroupInput>
    </>
  )
}